/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAddSyncEntity} from '../api'

export const useMutationBulkAddSyncEntity = createReactQueryMutationHook('bulkAddSyncEntity', bulkAddSyncEntity)
